import { Grid } from '@mui/material';
import { useContext } from 'react';

import ContractTypes from './ContractTypes';
import ProjectTags from './ProjectTags';

import ProjectSettings from '@/components/ProjectSettings';
import { KickOffContext } from '@/Contexts/KickOff';

const Configurations: React.FC = () => {
  const { projectSettings, setProjectSettings } = useContext(KickOffContext);
  return (
    <Grid size={12} container>
      <ContractTypes />
      <ProjectTags />
      <Grid size={12}>
        <ProjectSettings settings={projectSettings} onSettingsChange={setProjectSettings} />
      </Grid>
    </Grid>
  );
};

export default Configurations;
